import React from 'react'
import { View } from 'react-native'
import { Divider } from '@ui-kitten/components'
import { StyleService, useStyleSheet } from '@src/style/service'
import { Text } from '@components/base'

interface SubscriptionFieldProps {
  name: string
  value: string
  secondaryValue?: string
  size?: 'normal' | 'small'
  showDivider?: boolean
}

export const SubscriptionField = (props: SubscriptionFieldProps) => {
  const styles = useStyleSheet(themedStyle)
  const { name, value, secondaryValue, size = 'normal', showDivider = true } = props
  const isSmall = size === 'small'
  const dividerInsetStyle = size === 'small' ? styles.smallDividerInset : styles.normalDividerInset

  return (
    <>
      <View style={[styles.field, styles[size]]}>
        <Text type="regular">{name}</Text>
        <View style={styles.textContainer}>
          <Text type={isSmall ? 'regular' : 'large'} bold numberOfLines={1} lineSpacing="none">
            {value}
          </Text>
          {!!secondaryValue && (
            <Text type="regular" style={styles.textSecondary} numberOfLines={1} lineSpacing="none">
              {secondaryValue}
            </Text>
          )}
        </View>
      </View>
      {showDivider && <Divider style={dividerInsetStyle} />}
    </>
  )
}

const themedStyle = StyleService.create({
  field: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    minHeight: 64,
  },
  normal: {
    paddingHorizontal: 16,
    paddingVertical: 12,
  },
  small: {
    paddingHorizontal: 0,
    paddingVertical: 12,
  },
  textSecondary: {
    marginTop: 4,
    color: 'theme.text.secondary',
  },
  textContainer: {
    alignItems: 'flex-end',
    justifyContent: 'space-between',
  },
  normalDividerInset: {
    marginHorizontal: 16,
  },
  smallDividerInset: {
    marginHorizontal: 0,
  },
})
